import { IconName } from '@frontend/icons';

export enum Verticals {
  DENTAL = 'Dental',
  ORTHO = 'Ortho',
  VET = 'Vet',
  OPTO = 'Opto',
  MEDICAL = 'Medical',
  MEDSPA = 'MedSpa',
  ALL = 'All',
}

export const verticalsIconNameMap: Record<Verticals, IconName> = {
  [Verticals.DENTAL]: 'tooth',
  [Verticals.ORTHO]: 'bone',
  [Verticals.VET]: 'paw',
  [Verticals.OPTO]: 'view',
  [Verticals.MEDICAL]: 'medical-filled',
  [Verticals.MEDSPA]: 'hourglass',
  [Verticals.ALL]: 'analytics',
};

export enum Confirmation {
  YES = 'Yes',
  NO = 'No',
}

export enum UserRole {
  ENGINEERING = 'ENGINEERING',
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  PRODUCT = 'PRODUCT',
  ONBOARDING_CSM_SW = 'ONBOARDING_CSM_SW',
  LEADERSHIP = 'LEADERSHIP',
  ALL = 'ALL',
}

export enum ReleaseStatus {
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  GA = 'GA',
}
